/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModalityTransactionDto
 */
export interface ModalityTransactionDto {
    /**
     * Transaction ID
     * @type {string}
     * @memberof ModalityTransactionDto
     */
    id: string;
    /**
     * Transaction datetime
     * @type {Date}
     * @memberof ModalityTransactionDto
     */
    datetime: Date;
    /**
     * Number of modality slots purchased
     * @type {number}
     * @memberof ModalityTransactionDto
     */
    quantity: number;
    /**
     * Total amount in cents
     * @type {number}
     * @memberof ModalityTransactionDto
     */
    totalAmount: number;
    /**
     * Payment status
     * @type {string}
     * @memberof ModalityTransactionDto
     */
    status: string;
    /**
     * Invoice ID for viewing invoice
     * @type {string}
     * @memberof ModalityTransactionDto
     */
    invoiceId: string;
    /**
     * Currency code
     * @type {string}
     * @memberof ModalityTransactionDto
     */
    currency: string;
    /**
     * PDF URL
     * @type {string}
     * @memberof ModalityTransactionDto
     */
    pdfUrl: string;
    /**
     * Hosted invoice URL
     * @type {string}
     * @memberof ModalityTransactionDto
     */
    hostedInvoiceUrl: string;
}

/**
 * Check if a given object implements the ModalityTransactionDto interface.
 */
export function instanceOfModalityTransactionDto(value: object): value is ModalityTransactionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('datetime' in value) || value['datetime'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('invoiceId' in value) || value['invoiceId'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('pdfUrl' in value) || value['pdfUrl'] === undefined) return false;
    if (!('hostedInvoiceUrl' in value) || value['hostedInvoiceUrl'] === undefined) return false;
    return true;
}

export function ModalityTransactionDtoFromJSON(json: any): ModalityTransactionDto {
    return ModalityTransactionDtoFromJSONTyped(json, false);
}

export function ModalityTransactionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModalityTransactionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'datetime': (new Date(json['datetime'])),
        'quantity': json['quantity'],
        'totalAmount': json['totalAmount'],
        'status': json['status'],
        'invoiceId': json['invoiceId'],
        'currency': json['currency'],
        'pdfUrl': json['pdfUrl'],
        'hostedInvoiceUrl': json['hostedInvoiceUrl'],
    };
}

export function ModalityTransactionDtoToJSON(json: any): ModalityTransactionDto {
    return ModalityTransactionDtoToJSONTyped(json, false);
}

export function ModalityTransactionDtoToJSONTyped(value?: ModalityTransactionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'datetime': ((value['datetime']).toISOString()),
        'quantity': value['quantity'],
        'totalAmount': value['totalAmount'],
        'status': value['status'],
        'invoiceId': value['invoiceId'],
        'currency': value['currency'],
        'pdfUrl': value['pdfUrl'],
        'hostedInvoiceUrl': value['hostedInvoiceUrl'],
    };
}

